export enum V2CardAgentToolName {
  SearchSignal = 'searchSignal',
  SetSignal = 'setSignal',
  SearchFeedValues = 'searchFeedValues',
  ReadValuesFromExcel = 'readValuesFromExcel',
  GetCardDetails = 'getCardDetails',
  SetCardName = 'setCardName',
  SetCardDescription = 'setCardDescription',
  DeleteOutput = 'deleteOutput',

  AddOrUpdateConditionCard = 'addOrUpdateConditionCard',
  AddConditionOutput = 'addConditionOutput',
  UpdateConditionOutput = 'updateConditionOutput',
  RemoveConditionOutput = 'removeConditionOutput',
  FinalizeCondition = 'finalizeCondition',
}
